import { motion, AnimatePresence } from "framer-motion";
import { Mail, CalendarCheck, ArrowUp } from "lucide-react";
import { useState, useEffect } from "react";

export const MobileBottomBar = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setShowScrollTop(window.scrollY > 500);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Scroll to Top Button - appears after 500px scroll, mobile only */}
      <AnimatePresence>
        {showScrollTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.5, y: 20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={scrollToTop}
            className="fixed bottom-[88px] right-4 z-50 md:hidden w-11 h-11 rounded-full bg-gradient-to-br from-primary to-[var(--violet-mid)] text-foreground shadow-lg flex items-center justify-center active:scale-90 transition-transform"
            aria-label="Scroll to top"
          >
            <ArrowUp className="w-5 h-5" />
          </motion.button>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 1.5, duration: 0.5, ease: "easeOut" }}
        className="fixed bottom-0 left-0 right-0 z-50 md:hidden"
      >
        {/* Gradient fade above bar */}
        <div className="h-6 bg-gradient-to-t from-background to-transparent pointer-events-none" />

        <div className="bg-background/95 backdrop-blur-xl border-t border-primary/20 px-4 py-3 flex items-center gap-3 safe-area-pb">
          {/* Email Button */}
          <a
            href="mailto:hello@marjohnrobillo.com"
            className="flex-1 flex items-center justify-center gap-2 py-3 rounded-2xl border border-primary/30 bg-card/60 text-foreground font-heading font-bold text-[13px] active:scale-95 transition-transform"
          >
            <Mail className="w-4 h-4 text-secondary" />
            <span>Email Me</span>
          </a>

          {/* Book a Call Button */}
          <a
            href="/book"
            className="flex-1 flex items-center justify-center gap-2 py-3 rounded-2xl bg-gradient-to-br from-[var(--accent-warm)] to-[var(--accent-warm-bright)] text-primary-foreground font-heading font-bold text-[13px] shadow-[var(--glow-cta)] active:scale-95 transition-transform animate-pulse"
          >
            <CalendarCheck className="w-4 h-4" />
            <span>Book a Call</span>
          </a>
        </div>
      </motion.div>
    </>
  );
};
